import 'bootstrap'
import $ from "jquery";

import {
    showToastNotify,
    TOASTR_ERROR,
    TOASTR_SUCCESS
} from "./helpers";

const ERROR_INPUT = 'error-input-group';
const NON_VISIBLE = 'd-none';

const setDisabledBtn = (value) => {
    $('#auth-btn-action').prop('disabled', value);
}

const signIn = () => {
    const emailBox = $('#sign-in-email');
    const email = emailBox.val();
    const passwordBox = $('#sign-in-password');
    const password = passwordBox.val();
    const csrfTokenBox = $('#csrf_token');
    const csrfToken = csrfTokenBox.val();
    const emailError = $('#sign-in-email-error');
    const passwordError = $('#sign-in-password-error');
    const recaptchaValueBox = $('#recaptcha-answer');
    const recaptchaValue = recaptchaValueBox.val();

    setDisabledBtn(true);

    if (!email || !password) {
        setDisabledBtn(false);
        if (!email) {
            emailError.removeClass(NON_VISIBLE);
            emailBox.addClass(ERROR_INPUT);
        }
        if (!password) {
            passwordError.removeClass(NON_VISIBLE);
            passwordBox.addClass(ERROR_INPUT);
        }
    } else {
        const isStandalone = displayStandalone()
        const data = {
            'email': email,
            'password': password,
            'recaptchaValue': recaptchaValue,
            'csrfToken': csrfToken,
            'displayStandalone': isStandalone,

        };
        sendAuthPost('sign-in', false, false, data, true, '/instant');
    }
}

const signUp = () => {
    const emailBox = $('#sign-up-email');
    const email = emailBox.val()
    const passwordBox = $('#sign-up-password');
    const password = passwordBox.val();
    const csrfTokenBox = $('#csrf_token');
    const csrfToken = csrfTokenBox.val();
    const confirmPasswordBox = $('#sign-up-password-confirm');
    const confirmPassword = confirmPasswordBox.val();
    const emailError = $('#sign-up-email-error');
    const passwordError = $('#sign-up-password-error');
    const passwordConfirmSignUp = $('#sign-up-password-confirm-error');
    const notConfirmSignUp = $('#sign-up-password-not-confirm-error');
    const agreeTerms = $("#agree_terms").prop('checked');
    const agreeTermsError = $("#agree_terms_error");
    const passwordMinLengthError = $("#sign-up-password-min-length-error");
    const passwordComplexityError = $("#sign-up-password-complexity-error");
    let regexp = /^(?=.*[0-9])(?=.*[A-ZА-Я])([а-яА-Яa-zA-Z0-9\D]{8,})$/;
    const verifyPassComplication = regexp.test(password);
    const passwordLength = password.length;

    setDisabledBtn(true);

    if (!email || !password || !confirmPassword || password != confirmPassword || !agreeTerms || !verifyPassComplication
    || passwordLength < 8 ) {
        setDisabledBtn(false);
        if (!email) {
            emailError.removeClass(NON_VISIBLE);
            emailBox.addClass(ERROR_INPUT);
        }
        if (!password) {
            passwordError.removeClass(NON_VISIBLE);
            passwordBox.addClass(ERROR_INPUT);
        }
        if (!confirmPassword) {
            passwordConfirmSignUp.removeClass(NON_VISIBLE);
            confirmPasswordBox.addClass(ERROR_INPUT);
        }
        if (passwordLength < 8) {
            passwordMinLengthError.removeClass(NON_VISIBLE)
        }
        if (!verifyPassComplication) {
            passwordComplexityError.removeClass(NON_VISIBLE)
        }
        if (password != confirmPassword) {
            notConfirmSignUp.removeClass(NON_VISIBLE);
        }
        if (!agreeTerms) {
            agreeTermsError.removeClass(NON_VISIBLE)
        }
    } else {
        const isStandalone = displayStandalone();

        const data = {
            'email': email,
            'password': password,
            'csrfToken': csrfToken,
            'displayStandalone': isStandalone,
        };
        sendAuthPost('sign-up', false, false, data, true, '/sign-in-registered', 'registered');
    }
}

const recoveryPassword = () => {
    const emailBox = $('#recovery-email');
    const email = emailBox.val();
    const emailError = $('#recovery-email-error');
    const csrfTokenBox = $('#csrf_token');
    const csrfToken = csrfTokenBox.val();
    const recaptchaValueBox = $('#recaptcha-answer');
    const recaptchaValue = recaptchaValueBox.val();

    if (!email) {
        emailError.removeClass(NON_VISIBLE);
        emailBox.addClass(ERROR_INPUT)
    } else {
        const data = {
            'email': email,
            'recaptchaValue': recaptchaValue,
            'csrfToken': csrfToken
        };
        sendAuthPost('recovery-password', false, true, data, false, '/sign-in');
    }
}

const clearAuthErrors = (type) => {
    $('#' + type + '-email-error').addClass(NON_VISIBLE);
    $('#' + type + '-email').removeClass(ERROR_INPUT);
    if (type !== 'recovery') {
        $('#' + type + '-password-error').addClass(NON_VISIBLE);
        $('#' + type + '-password').removeClass(ERROR_INPUT);
        if (type === 'sign-up') {
            $('#' + type + '-password-confirm-error').addClass(NON_VISIBLE);
            $('#' + type + '-password-confirm').removeClass(ERROR_INPUT);
            $('#' + type + '-password-not-confirm-error').addClass(NON_VISIBLE);
            $('#' + type + '-password-min-length-error').addClass(NON_VISIBLE);
            $('#' + type + '-password-complexity-error').addClass(NON_VISIBLE);
            $('#agree_terms_error').addClass(NON_VISIBLE);
        }
        if (type === 'recovery-change-pass') {
            $('#recovery-password-confirm-error').addClass(NON_VISIBLE)
            $('#recovery-password-not-confirm-error').addClass(NON_VISIBLE)
        }
    }
}

const recoveryChangePass = () => {
    const recoveryPasswordBox = $('#recovery-password');
    const password = recoveryPasswordBox.val();
    const confirmPasswordBox = $('#recovery-password-confirm');
    const confirmPassword = confirmPasswordBox.val();
    const passwordError = $('#recovery-password-password');
    const passwordConfirmSignUp = $('#recovery-password-confirm-error');
    const notConfirmSignUp = $('#recovery-password-not-confirm-error');
    if (!password || !confirmPassword || password != confirmPassword) {
        if (!password) {
            passwordError.removeClass(NON_VISIBLE);
            recoveryPasswordBox.addClass(ERROR_INPUT);
        }
        if (!confirmPassword) {
            passwordConfirmSignUp.removeClass(NON_VISIBLE);
            confirmPasswordBox.addClass(ERROR_INPUT);
        }
        if (password != confirmPassword) {
            notConfirmSignUp.removeClass(NON_VISIBLE);
        }
    } else {
        const data = {
            'password': password,
        };
        sendAuthPost('recovery-change-password', false, false, data, true, '/sign-in');
    }
}

const redirect = (url) => {
    location.href = url
}

const checkGgAuthCode = () => {
    const authCodeBox = $('#google-auth-code');
    const authCodeVal = authCodeBox.val();
    const authCodeError = $('#google-auth-code-error');
    if (!authCodeVal) {
        authCodeError.removeClass(NON_VISIBLE);
        authCodeBox.addClass(ERROR_INPUT)
    } else {
        const data = {
            '2fa_code': authCodeVal,
        };
        sendAuthPost('2fa-auth', false, false, data, true, '/instant');
    }
}

export const sendAuthPost = (url, needReload = false, needResponse = false, data,
                      needRedirect = false, redirectUrl = '', type = null,
                      needShowPopup = false, popupName = '') => {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            let message = 'Something wrong';

            if (result) {
                if (result.msg) {
                    message = result.msg
                }
                if (!result.error) {
                    if (!result.auth_redirect) {
                        if (needShowPopup && popupName) {
                            $('#authModal').modal('hide')
                            $('#' + popupName).modal('show');
                        }
                        if (needResponse) {
                            showToastNotify(TOASTR_SUCCESS, '', message)
                        }
                        if (needReload) {
                            window.setTimeout(function () {
                                location.reload()
                            }, 3000);
                        }
                        if (needRedirect) {
                            if (type === 'registered' && result.reg_email) {
                                redirectUrl = redirectUrl + '?email=' + result.reg_email;
                            }
                            location.href = redirectUrl;
                        }
                    } else {
                        if (result.errMsg) {
                            showToastNotify(TOASTR_ERROR, '', result.errMsg);
                            window.setTimeout(function () {
                                location.href = result.auth_redirect;
                            }, 500);
                        } else {
                            location.href = result.auth_redirect;
                        }
                    }
                } else {
                    showToastNotify(TOASTR_ERROR, '', message);
                    setDisabledBtn(false);

                    if (typeof (grecaptcha) != "undefined") {
                        grecaptcha.reset();
                    }
                }
            }
        }
    });
}

const displayStandalone = () => {
    return navigator.standalone || window.matchMedia('(display-mode: standalone)').matches
}

window.signIn = signIn;
window.signUp = signUp;
window.recoveryPassword = recoveryPassword;
window.clearAuthErrors = clearAuthErrors;
window.redirect = redirect;
window.recoveryChangePass = recoveryChangePass;
window.checkGgAuthCode = checkGgAuthCode;

document.onkeyup = function (e) {
    e = e || window.event;
    if (e.keyCode === 13) {
        $("#auth-btn-action").click();
    }
    return false;
}
